<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>{{ title }} Usuário</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
          <b-row v-if="!edit && !visualizar">
            <b-col sm="2" class="text-center"></b-col>
              <b-col sm="4" class="text-center">
                <div class="container-denuncia c1">
                  <a class="button-denuncia b1" :style="isClickedAdmin ? { 'background': '#E87E04' } : null" @click="toggleIsClickedAdmin()">Administrador</a>
                </div>
              </b-col>
              <b-col sm="4" class="text-center">
                <div class="container-denuncia c1">
                  <a class="button-denuncia b1" :style="isClickedVisualizador ? { 'background': '#E87E04' } : null" @click="toggleIsClickedVisualizador()">Visualizador</a>
                </div>
              </b-col>
            <b-col sm="2" class="text-center"></b-col>
            <br>
            <br>
            <br>
          </b-row>
            <b-form v-on:submit.prevent="onSubmit">
              <b-alert v-if="alerta_pre_cadastro" show variant="warning">{{mensagem_pre_cadastro}}</b-alert>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="CPF:*">
                    <b-input-group class="mb-6">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-mask="'###.###.###-##'"
                                    type="text"
                                    class="form-control"
                                    placeholder="CPF"
                                    autocomplete="cpf"
                                    :disabled="visualizar"
                                    v-model="$v.form.cpf.$model"
                                    :state="chkState('cpf')"
                                    autofocus/>
                      <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              <b-col cols="6">
                  <b-form-group label="Nome:*">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Nome"
                                    :disabled="visualizar"
                                    autocomplete="nome"
                                    v-model.trim="$v.form.nome.$model"
                                    :state="chkState('nome')"/>
                      <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <b-form-group label="DDD + Telefone:">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    v-mask="'+55 (##) #####-####'"
                                    class="form-control"
                                    placeholder="Telefone"
                                    :disabled="visualizar"
                                    autocomplete="telefone"
                                    v-model.lazy.trim="$v.form.telefone.$model"
                                    :state="chkState('telefone')"/>
                      <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <b-form-group label="E-mail:*">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>@</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="E-mail"
                                    :disabled="visualizar"
                                    autocomplete="email"
                                    v-model.trim="$v.form.email.$model"
                                    :state="chkState('email')"/>
                      <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                        endereço de e-mail válido.
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="filtros.btnFormVisualizador">
                <b-col sm="4">
                    <b-form-group label="UF:*">
                        <b-form-select :disabled="visualizar"
                        v-model="$v.form.uf.$model" :state="chkState('uf')" :options="estados">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                        <b-form-invalid-feedback id="input1LiveFeedback1">UF é obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group label="Município:*" :disabled="disabled_cidades">
                        <b-form-select
                                v-model="$v.form.municipio.$model"
                                :disabled="visualizar"
                                :options="cidades"
                                :state="chkState('municipio')">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                        <b-form-invalid-feedback id="input1LiveFeedback3">Município é obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Instituição:*">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    :disabled="visualizar"
                                    placeholder="Instituição"
                                    autocomplete="nome"
                                    v-model.trim="$v.form.instituicao.$model"
                                    :state="chkState('instituicao')"/>
                      <b-form-invalid-feedback id="input1LiveFeedback3">Instituição é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
               <b-col cols="12">
                <label>Observação:</label>
                <b-form-textarea id="textarea" :disabled="visualizar" :state="chkState('observacao')" placeholder="Observação" v-model="$v.form.observacao.$model" rows="3" max-rows="6"></b-form-textarea>
                 <b-form-invalid-feedback id="input1LiveFeedback1">Observação é obrigatório.</b-form-invalid-feedback>
              </b-col>
            </b-row>
            </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="3" offset-md="3" v-if="!visualizar">
              <b-button block variant="primary" v-on:click="onSubmit">
                <span>Salvar</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, minLength, email, sameAs, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import { cpf } from 'cpf-cnpj-validator'; 

miniToastr.init()

const formShape = {
  cpf: '',
  nome: '',
  telefone: '',
  email: '',
  uf: null,
  municipio: null,
  instituicao: '',
  observacao: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      nome: {
        required
      },
      telefone: {},
      email: {
        required,
        email
      },
      observacao: {
        // required
      },
      uf: {
        required: requiredIf(function(){          
          if(this.filtros.btnFormVisualizador){
            return true
          }
          return false
        })
      },
      municipio: {
        required: requiredIf(function(){          
          if(this.filtros.btnFormVisualizador){
            return true
          }
          return false
        })
      },
      instituicao: {
        required: requiredIf(function(){          
          if(this.filtros.btnFormVisualizador){
            return true
          }
          return false
        })
      }
    }
  },
  created () {
    if (!this.can('user.store')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('buscarEstados')
      if (this.$route.params.id !== undefined) {
        this.$store.dispatch('getUsuario', this.$route.params.id)
      }
    }
  },
  data () {
    return {
      visualizar: false,
      title: 'Cadastrar',
      edit: false,
      isClickedAdmin: true,
      isClickedVisualizador: false,
      perfil_id: null,
      admin_perfil_id: 1,
      visualizador_perfil_id: 8,
      cadastroInterno: true,
      orgao: null,
      orgaoState: true,
      unidade: null,
      unidadeState: true,
      form: Object.assign({}, formShape),
      status_aceite: 'not_accepted',
      disabled_cidades: true,
      disabled_unidade: true,
      disable_buttons: false,
      valueAceiteTipoUsuario: false,
      titulo_toast: 'Alerta!',
      options: [
        {value: true}
      ],
      options2: [
        {value: true}
      ],
      alerta_pre_cadastro: false,
      mensagem_pre_cadastro: '',
      filtros: {
        btnFormAdmin: true,
        btnFormVisualizador: false
      }
    }
  },
  mounted () {
    let rota = this.$router.currentRoute.fullPath
    if (rota !== '/usuario/cadastrar') {
      if (rota.indexOf('editar') !== -1) {
        this.edit = true
        this.title = 'Editar'
      } else {
        this.title = 'Visualizar'
        this.visualizar = true
      }
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    unidades () {
      return this.$store.state.unidade.listaUnidadesPorOrgao
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'usuario': function () {
        this.$v.form.cpf.$model = this.usuario.cpf
        this.$v.form.nome.$model = this.usuario.nome
        this.$v.form.telefone.$model = (this.usuario.dados !== null) ? this.usuario.dados.telefone : null
        this.$v.form.email.$model = this.usuario.email
        this.$v.form.observacao.$model = (this.usuario.dados !== null) ? this.usuario.dados.observacao : null

        if (this.usuario.perfil_id == 1) {
          this.filtros.btnFormAdmin = true
        }
        if (this.usuario.perfil_id == 8) {
          this.filtros.btnFormVisualizador = true
          this.$v.form.uf.$model = (this.usuario.dados !== null) ? this.usuario.dados.municipio.estado.id : null
          this.$v.form.municipio.$model = (this.usuario.dados !== null) ? this.usuario.dados.municipio_id : null
          this.$v.form.instituicao.$model = (this.usuario.dados !== null) ? this.usuario.dados.instituicao : null
        }
    },
    'filtros.btnFormAdmin': function () {
      if (this.filtros.btnFormAdmin) {
        this.filtros.btnFormVisualizador = false
      }
    },
    'filtros.btnFormVisualizador': function () {
      if (this.filtros.btnFormVisualizador) {
        this.filtros.btnFormAdmin = false
      }
    },
    '$v.form.uf.$model': function () {
      if (this.$v.form.uf.$model !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.$v.form.uf.$model)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
      }
    }
  },
  methods: {
    toggleIsClickedAdmin () {
      if (!this.isClickedAdmin) {
        this.isClickedAdmin = !this.isClickedAdmin
        this.isClickedVisualizador = false
        this.exibeAdmin()
      }
    },
    toggleIsClickedVisualizador () {
      if (!this.isClickedVisualizador) {
        this.isClickedVisualizador = !this.isClickedVisualizador
        this.isClickedAdmin = false
        this.exibeVisualizador()
      }
    },
    exibeAdmin () {
      this.form = Object.assign({}, formShape)
      this.$nextTick(() => { 
        this.$v.$reset() 
      })
      this.filtros.btnFormAdmin = true
      this.filtros.btnFormVisualizador = false
    },
    exibeVisualizador () {
      this.form = Object.assign({}, formShape)
      this.$nextTick(() => { 
        this.$v.$reset() 
      })
      this.filtros.btnFormVisualizador = true
      this.filtros.btnFormAdmin = false
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {

      this.perfil_id = (this.filtros.btnFormAdmin) ? this.admin_perfil_id : this.visualizador_perfil_id
      let form = this.$v.form
      let data = {
        id: (this.edit) ? this.usuario.id : null,
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        nome: form.nome.$model,
        telefone: (form.telefone.$model !== null ) ? form.telefone.$model.replace(/[^\d]+/g, '') : null,
        estado_id: parseInt(form.uf.$model),
        cidade_id: parseInt(form.municipio.$model),
        email: form.email.$model,
        email_confirmation: form.email.$model,
        ativo: true,
        ignorarCaptcha: true,
        perfil_id: this.perfil_id,
        situacao: true,
        instituicao: form.instituicao.$model,
        observacao: form.observacao.$model
      }

      this.disable_buttons = true
      Vue.http.post('api/usuario', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          if (this.cadastroInterno) {
            let msg = (this.edit) ? 'Usuário alterado com sucesso!' : 'Usuário cadastrado com sucesso!'
            miniToastr.success(msg, 'Sucesso!', 7000)
          } else {
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          }

          this.$router.push({path: '/usuarios'})
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate() && this.validateCpf()) {
        this.confirmar()
      }
    },
    validateCpf () {
      let cpfValido = this.$v.form.cpf.$model.replace(/[^\d]+/g, '')
      if (!cpf.isValid(cpfValido)) {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('O CPF informado não é válido', 'Alerta', 5000)
        return false
      }
      return true
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>
<style>
  .container-denuncia {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50%;
  }
  .container-denuncia.c1 {
    text-align: center;
  }
  .container-denuncia.c2 {
    text-align: center; 
  }
  .button-denuncia {
    padding: 5px 10px;
    font-size: 20px;
    text-decoration: none;
    color: rgb(0, 0, 0);
    background: linear-gradient(#f0f3f5, #f0f3f5);
    border-radius: 5px;
    box-shadow: 2px 2px 15px -5px hsla(0, 0%, 0%, 1);
  }
  .button-denuncia:hover {
    background: linear-gradient(rgb(169, 170, 172), rgb(169, 170, 172));
    transition: all 0.2s linear;
    cursor: pointer;
  }
  .button-denuncia.b1 {
      display: inline-flex;
      width: -webkit-fill-available;
      justify-content: center;
  }
  .button-denuncia.b2 {
      display: inline-flex;
      width: -webkit-fill-available;
      justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioCadastrar.vue